// Collection page, pootoo layout (sections/mh-collection-pt.liquid, 2026-09-23):
// filter column / drawer toggle, category-tile arrows (card behaviour: assets/mh-product-card-pt.js).
// mh-category-filter.js swaps the whole [data-mh-catalog] after every filter/sort/page change and carries
// the open state over (data-mh-pt-open), so everything here is delegated or re-run on mh:idle.
(() => {
  if (window.mhCollectionPt) return;
  window.mhCollectionPt = true;

  const drawerMedia = window.matchMedia('(max-width: 989px)');
  const focusable = 'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const catalog = () => document.querySelector('.mh-catalog--pt');
  let returnFocus = null;
  let lockedScroll = false;

  const sync = (root = catalog()) => {
    if (!root) return;
    const open = root.hasAttribute('data-mh-pt-open');
    const drawer = drawerMedia.matches;
    root.querySelectorAll('[data-mh-pt-filter-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(open)));
    const panel = root.querySelector('[data-mh-pt-filters]');
    const scrim = root.querySelector('.mh-pt-scrim');
    if (scrim) scrim.hidden = !(open && drawer);
    if (panel) {
      if (open && drawer) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
    }
    // Only release a lock this script took, so another open dialog keeps its own.
    const lock = open && drawer;
    if (lock !== lockedScroll) {
      document.documentElement.style.overflow = lock ? 'hidden' : '';
      lockedScroll = lock;
    }
  };

  const setOpen = (open, { focus = true } = {}) => {
    const root = catalog();
    if (!root) return;
    root.toggleAttribute('data-mh-pt-open', open);
    sync(root);
    if (!focus) return;
    if (open && drawerMedia.matches) {
      returnFocus = document.activeElement;
      root.querySelector('[data-mh-pt-filter-close]')?.focus({ preventScroll: true });
    } else if (!open) {
      const usable = returnFocus?.isConnected && returnFocus !== document.body && !root.querySelector('[data-mh-pt-filters]')?.contains(returnFocus);
      (usable ? returnFocus : root.querySelector('[data-mh-pt-filter-toggle]'))?.focus({ preventScroll: true });
      returnFocus = null;
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest?.('.mh-catalog--pt [data-mh-pt-filter-toggle]')) {
      setOpen(!catalog()?.hasAttribute('data-mh-pt-open'));
    } else if (event.target.closest?.('.mh-catalog--pt [data-mh-pt-filter-close]')) {
      setOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    const root = catalog();
    if (!root?.hasAttribute('data-mh-pt-open') || !drawerMedia.matches) return;
    if (event.key === 'Escape' && !event.target.closest('details[open] > :not(summary)')) {
      setOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const panel = root.querySelector('[data-mh-pt-filters]');
    const items = Array.from(panel.querySelectorAll(focusable)).filter((el) => el.getClientRects().length);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!panel.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    else if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  drawerMedia.addEventListener('change', () => sync());

  // Category tiles: arrows appear only when the row overflows (desktop / tablet).
  const initTiles = (root) => {
    root?.querySelectorAll('[data-mh-pt-tiles]').forEach((nav) => {
      if (nav.dataset.mhReady) return;
      nav.dataset.mhReady = 'true';
      const track = nav.querySelector('[data-mh-pt-tiles-track]');
      const prev = nav.querySelector('[data-mh-pt-tiles-prev]');
      const next = nav.querySelector('[data-mh-pt-tiles-next]');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = max <= 4 || track.scrollLeft >= max - 4;
      };
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  };

  // Sticky utility bar on phones sits under the sticky masthead.
  const header = document.querySelector('.mh-header-sticky');
  if (header) {
    const setOffset = () => document.documentElement.style.setProperty('--mh-catalog-header-height', `${header.getBoundingClientRect().height}px`);
    setOffset();
    if ('ResizeObserver' in window) new ResizeObserver(setOffset).observe(header);
  }

  const init = () => {
    initTiles(document);
    sync(catalog());
  };
  document.addEventListener('mh:idle', (event) => { if (event.detail?.source === 'category-filter') init(); });
  document.addEventListener('shopify:section:load', init);
  init();
})();
